/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';

export const actions = {
  async profil({ rootState }) {
    const id = rootState.auth.instansi_id;
    return http.get(`psp/i/${id}/profil`).then(({ data }) => data);
  },

  password({ rootState }, params) {
    const id = rootState.auth.instansi_id;
    return http.post(`psp/i/${id}/profil/password`, params).then(({ data }) => data);
  },

  // eslint-disable-next-line no-empty-pattern
  uploadFoto({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/profil/foto`;
    return http.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  saveProfil({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/profil/save`;
    return http.post(url, payload.params);
  },
};
